import { MRNApi } from '../../../api/HSEQ/MRN'
import MRN from '../../../components/HSEQ/MRN/MRN'
import MRNList from '../../../components/HSEQ/MRN/MRNList'
import useFetchList from '../../../elements/Hooks/useFetchList'
import useListCompanyFilter from '../../../elements/Hooks/useListCompanyFilter'
import useTitle from '../../../elements/Hooks/useTitle'
import React from 'react'

function MRNCont(props) {
  const { delivery } = props
  const { list: cached, fetching, fetch } = useFetchList(() =>
    delivery ? MRNApi.getMRNByDelivery(delivery._key) : MRNApi.list()
  )
  const { list, company, onChangeCompany } = useListCompanyFilter(cached, fetching)
  useTitle('Material Release Notes')

  const propsProps = {
    list,
    fetching,
    fetch,
    company,
    onChangeCompany,
  }

  return delivery ? <MRNList {...propsProps} /> : <MRN {...propsProps} />
}

MRNCont.propTypes = {}
MRNCont.defaultProps = {}

export default MRNCont
